import GpsHelper from "./GpsHelper";

type TSearchQueryType = "street" | "address" | "gps" | "zone" | "parkingMachine";

export default class SearchQueryHelper {
    public getSearchQueryType(query: string): TSearchQueryType|null {
        if (this.isGpsCoords(query)) { return "gps"; }
        if (this.isZone(query)) { return "zone"; }
        if (this.isParkingMachine(query)) { return "parkingMachine"; }
        if (this.isAddress(query)) { return "address"; }
        if (this.isStreet(query)) { return "street"; }
        return null;
    }

    public isGpsCoords(query: string): boolean {
        const gpsResult = GpsHelper.isCoordinate(query);
        return gpsResult.result;
    }

    public isAddress(query: string): boolean {
        const addressRegex = /^(\D+) (\d+)$/;
        return addressRegex.test(query);
    }

    public isStreet(query: string): boolean {
        const streetRegex = /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ ]+$/;
        return streetRegex.test(query);
    }

    public isZone(query: string): boolean {
        return  query.match(/P\d+.*/gim) !== null || query.match(/BUS.*/gim) !== null;
    }

    public isParkingMachine(query: string): boolean {
        const parkingMachineRegex = /^\d+$/;
        return parkingMachineRegex.test(query);
    }
}
